import { Controller } from "stimulus";
import Chart from 'chart.js';
import formatDollars from "../../stylesheets/utility/format_dollars";


export default class VarietalIncomeAndCostsController extends Controller {
  static targets = [
    "measure",
    "chart",
    "year",
    "variety",
  ];
  chart;

  connect() {
    this.chart = new Chart(this.chartTarget.getContext('2d'), { type: "bar" });
    this.redrawChart();
  }

  //
  // Update the data and labels and call chart.update()
  // for a smooth transition
  //
  redrawChart() {
    this.chart.data = this.getChartData();
    this.chart.options = {
      scales: {
        yAxes: [{
          ticks: {
            callback: (value) => formatDollars(value),
            beginAtZero: true,
          }
        }]
      },
      tooltips: {
        callbacks: {
          label: (tooltipItems) => formatDollars(tooltipItems.yLabel.toString(), { per: this.selectedMeasure() })
        }
      }
    };
    this.chart.update();
  }

  selectedMeasure(){
    return this.measureTargets.find(r => r.checked).value;
  }

  selectedVarieties(){
    return this.varietyTargets.filter(el => el.checked).map(el => el.value);
  }

  selectedYear() {
    return this.yearTargets.find(r => r.checked).value;
  }

  //
  // Build the data for chart.js, e.g.
  //
  // {
  //   labels: ["Cabernet Sauvignon", "Chardonnay"],
  //   datasets: [
  //     {
  //       label: "Income",
  //       backgroundColor: "#1f77b4",
  //       data: [2468,234]
  //     },
  //     {
  //       label: "Fixed & Variable Expenses",
  //       backgroundColor: "#aec7e8",
  //       data: [2412.62,703.38]
  //     }
  //   ]
  // }

  //
  getChartData() {
    const data = JSON.parse(this.data.get("report-data"));
    const varieties = this.selectedVarieties();
    const year = this.selectedYear();
    const measure = this.selectedMeasure();

    let buildRow = (dataset) =>
      varieties.map(variety =>
        data
          .filter(d => d.variety === variety && d.year === year)
          .map(d => d[dataset][measure])
          .reduce((a,b) => a + b, 0));

    return {
      labels: varieties,
      datasets: [
        {
          label: "Income",
          backgroundColor: "#1f77b4",
          data: buildRow('income')
        },
        {
          label: "Fixed & Variable Expenses",
          backgroundColor: "#aec7e8",
          data: buildRow('expenses')
        }
      ]
    };
  }
}
